import { OverlayRef } from '@angular/cdk/overlay';
import { ComponentPortal, PortalInjector } from '@angular/cdk/portal';
import { Directive, ElementRef, Injector, Input, OnInit, StaticProvider } from '@angular/core';
import { debounceTime, distinctUntilChanged, Observable } from 'rxjs';
import { DynamicOverlayService } from './dynamic-overlay.service';
import { OverlayLoaderComponent } from './overlay-loader.component';
import { LoaderData } from './overlay-loader.config';

@Directive({
  selector: '[cslOverlayLoader]',
})
export class OverlayLoaderDirective implements OnInit {
  @Input('cslOverlayLoader') toggler: Observable<boolean>;
  @Input() loaderData: LoaderData = new LoaderData();

  private overlayRef: OverlayRef;

  constructor(
    private host: ElementRef,
    private dynamicOverlay: DynamicOverlayService,
    private parentInjector: Injector
  ) {}

  ngOnInit(): void {
    this.overlayRef = this.dynamicOverlay.createWithDefaultConfig(this.host.nativeElement);

    this.toggler
      // anti flickering
      .pipe(debounceTime(50), distinctUntilChanged())
      .subscribe(show => {
        if (show) {
          const injector = this.getInjector(this.loaderData, this.parentInjector);
          const loaderPortal = new ComponentPortal(OverlayLoaderComponent, null, injector);

          this.overlayRef.attach(loaderPortal);
        } else {
          this.overlayRef.detach();
        }
      });
  }

  getInjector(data: LoaderData, parentInjector: Injector): Injector {
    const tokens: StaticProvider[] = [];

    tokens.push({ provide: LoaderData, useValue: data });

    return Injector.create({
      providers: tokens,
      parent: parentInjector,
    });
  }
}
